import React, { useEffect } from 'react';
import {useHistory} from 'react-router-dom';
// import styles from './dashboard.module.scss';
import Header from 'src/components/header/Header';
// import SpecialCourses from 'src/components/dashboard-special-courses/SpecialCourses';
// import Courses from '@src/components/dashboard-courses/Dashboard';
// import Footer from 'src/components/footer/Footer';
// import Spinner from 'src/components/spinner/Spinner';
import { useAuthToken } from 'src/hooks/useAuthToken';
// import { useParentProgramsQuery } from 'src/api/graphql-codegen';
import Caregiver from '../../standalone/Caregiver';

function ParentDashboard() {
  const history = useHistory();
  // const { data, loading, error } = useParentProgramsQuery({ fetchPolicy: 'network-only' });
  const { parentToken } = useAuthToken();
  // const { search } = useLocation();

  useEffect(() => {
    if (!parentToken) {
      history.goBack();
    }
  }, [history, parentToken]);

/*   const parentPrograms = useMemo(() => {
    if (loading || error) return [];
    return (data?.parentPrograms || []) as any[]
  }, [data?.parentPrograms, error, loading]);

  const specialCourseId = useMemo(() => {
    if (search) {
      const params = new URLSearchParams(search);
      const courseId = params.get('specialCourseId');
      return courseId
    }
    return undefined;
  }, [search]); */

  // const parentSpecialPrograms = useMemo(() => {
  //   if (loading || error) return [];
  //   return (data?.parentSpecialPrograms || []) as any[]
  // }, [data?.parentSpecialPrograms, error, loading]);

  return (
    <>
      <Header isParentApp />
      {/* <div className={styles.page}>
        {loading ? <div className={styles.spinner}><Spinner/></div> : <>
          {/* <SpecialCourses programs={parentSpecialPrograms} isParentApp />
          <Courses courses={parentPrograms} isParentApp specialCourseId={specialCourseId || undefined} />
        </>}
      </div> */}
      <Caregiver isPA />
    </>
  );
}

export default ParentDashboard;
